import React from 'react';

// =============================================================================
// EntityCardSkeleton — shape-of-card placeholder for sections that render
// an entity list / table card on load (Creatives, Publishers, Segments,
// Transactions, Sign Ups, Sessions, Referrers, Basket Items, etc.).
//
// Mirrors the `.campaign-overview__creatives` shell used by
// `<EntityBreakdownCard>` — header bar + body block. Composes the generic
// `.skeleton` shimmer primitive from `_design-system.scss` §20.
//
// Consumed by the tab-level loading states of every non-Overview tab plus
// Creatives/Publishers internally. See SPECIFICATION §10 consumer contract
// for the "shimmer-per-card" loading pattern.
// =============================================================================

const EntityCardSkeleton = () => (
  <section className="campaign-overview__creatives">
    <header className="campaign-overview__creatives-head">
      <span
        className="skeleton"
        style={{ width: 120, height: 12, borderRadius: 4 }}
      />
    </header>
    <div style={{ padding: 16 }}>
      <span
        className="skeleton"
        style={{
          width: '100%',
          height: 220,
          borderRadius: 12,
          display: 'block',
        }}
      />
    </div>
  </section>
);

export default EntityCardSkeleton;
